module.exports = __webpack_public_path__ + "img/payment_plan_1.27aa75dd.png";